/* pantallas-alumno (B): EL BOTON DE TEMAS (piezas nuevas de la parte 1; "Choose topics").

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Secundario a lo ancho, 44 px: icono de lista, el texto y una flecha a la derecha. Con temas
   elegidos (`conTemas`): fondo #241710, borde #3A2414, texto #F7A06A. Apagado: 45 %; con
   `apagadoSuave` se ve apagado y al tocarlo llama a `alTocarApagado`. */
import React from 'react';
import { ChevronRight, ListChecks } from 'lucide-react';
import { APRETADO } from './botones';
import { OPACIDAD_APAGADO } from './estilos';

export default function BotonDeTemas({
  texto, conTemas = false, onClick, disabled = false, apagadoSuave = false, alTocarApagado, testid,
}) {
  const color = conTemas
    ? 'bg-[#241710] border-[#3A2414] text-[#F7A06A]'
    : 'bg-[#1B1B1B] border-[#2C2C2C] text-[#F4F4F3]';
  const alTocar = (e) => {
    if (apagadoSuave) { if (alTocarApagado) alTocarApagado(e); return; }
    if (onClick) onClick(e);
  };
  return (
    <button
      type="button"
      onClick={alTocar}
      disabled={disabled}
      aria-disabled={apagadoSuave || undefined}
      style={apagadoSuave ? { opacity: OPACIDAD_APAGADO } : undefined}
      data-testid={testid}
      data-con-temas={conTemas ? 'true' : undefined}
      className={`w-full h-11 px-3.5 rounded-xl border ${color} text-[14px] font-semibold flex items-center gap-2.5 text-left disabled:opacity-45 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}
    >
      <ListChecks className="w-4 h-4 shrink-0" aria-hidden="true" />
      <span className="flex-1 min-w-0 truncate">{texto}</span>
      <ChevronRight className="w-4 h-4 shrink-0" aria-hidden="true" />
    </button>
  );
}
